import OCAISDK from '@openclassrooms/js-ai-sdk';

import { getAIRootURL } from '@openclassrooms/data-connect-web/utils';

import type { AIServerName } from '@openclassrooms/data-connect-web/utils';

import { sdk } from 'Modules/api';

export default function getClient({
  serverName,
  language,
}: {
  serverName?: AIServerName;
  language?: string;
} = {}): OCAISDK {
  if (!sdk.client) {
    throw new ReferenceError(
      `Calling ai.getClient() but no OpenClassrooms REST client has been set`
    );
  }

  if (!sdk.authClient) {
    throw new ReferenceError(
      `Calling ai.getClient() but no OpenClassrooms Auth client has been set`
    );
  }

  const client = new OCAISDK({
    accessToken: sdk.client.accessToken!,
  });

  sdk.authClient.onNewAccessToken(({ accessToken }) => {
    if (accessToken) {
      client.setAccessToken(accessToken);
    }
  });

  client.addRequestInterceptor(async (requestData) => {
    await sdk.authClient!.checkAccessTokenExpiration();
    return requestData;
  });

  if (serverName) {
    client.setRootUrl(getAIRootURL(serverName));
  }

  if (language) {
    client.setLanguage(language);
  }

  return client;
}
